import {instance, onErrorFunction, onSuccessFunction} from "../../../config/axios-cnf";

export const apiGetConfig = (subjectId, callback, error) => {
    instance.get("/api/v2/enigoo/" + subjectId + "/config")
        .then((response) => callback(onSuccessFunction(response.data)))
        .catch((err) => error(onErrorFunction(err)));
}

export const apiGetConfigKeys = (subjectId, callback, error) => {
    instance.get("/api/v2/enigoo/" + subjectId + "/config/keys")
        .then((response) => callback(onSuccessFunction(response.data)))
        .catch((err) => error(onErrorFunction(err)));
}

export const apiCreateConfig = (subjectId, data, callback, error) => {
    instance.post("/api/v2/enigoo/" + subjectId + "/config", data)
        .then((response) => callback(onSuccessFunction(response.data)))
        .catch((err) => error(onErrorFunction(err)));
}

export const apiUpdateConfig = (subjectId, id, data, callback, error) => {
    instance.put("/api/v2/enigoo/" + subjectId + "/config/" + id, data)
        .then((response) => callback(onSuccessFunction(response.data)))
        .catch((err) => error(onErrorFunction(err)));
}
